import React from 'react';
import { Check, ShieldCheck, Clock, Zap, Star } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
export function ValueStack() {
  return <section id="offer-section" className="py-16 md:py-24 bg-charcoal text-white relative overflow-hidden" data-id="element-286">
      {/* Background decoration */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-0 opacity-20" data-id="element-287">
        <div className="absolute -top-24 -right-24 w-96 h-96 bg-primary rounded-full blur-[100px]" data-id="element-288"></div>
        <div className="absolute -bottom-24 -left-24 w-96 h-96 bg-accent rounded-full blur-[100px]" data-id="element-289"></div>
      </div>

      <div className="max-w-5xl mx-auto px-4 relative z-10" data-id="element-290">
        {/* Gradient Border Wrapper */}
        <div className="rounded-[2rem] p-[3px] bg-gradient-to-br from-primary via-accent to-primary shadow-[0_0_50px_rgba(232,93,4,0.2)] relative" data-id="element-291">
          {/* Urgent Banner */}
          <div className="absolute -top-5 left-1/2 -translate-x-1/2 bg-red-600 text-white px-6 py-2.5 rounded-full font-bold text-sm md:text-base shadow-xl whitespace-nowrap flex items-center gap-2 z-20 border-2 border-white" data-id="element-292">
            <Clock className="w-5 h-5 animate-pulse" data-id="element-293" />
            Precio especial disponible por 24 horas
          </div>

          {/* Main Card Content */}
          <div className="bg-white text-charcoal rounded-[30px] p-6 md:p-12 relative overflow-hidden" data-id="element-294">
            {/* Subtle inner glow */}
            <div className="absolute top-0 right-0 w-64 h-64 bg-accent/5 rounded-full blur-3xl" data-id="element-295"></div>

            <div className="text-center mb-10 mt-4" data-id="element-296">
              <h2 className="text-3xl md:text-5xl font-heading font-black text-charcoal mb-4" data-id="element-297">
                Resumen de tu Pedido
              </h2>
              <p className="text-charcoal-muted font-medium text-lg" data-id="element-298">
                Todo lo que necesitas para dominar tu Airfryer hoy mismo
              </p>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-5 gap-8 lg:gap-12 mb-10" data-id="element-299">
              {/* What you get */}
              <div className="lg:col-span-3" data-id="element-300">
                <h3 className="text-xl font-black text-charcoal uppercase tracking-wider mb-6 flex items-center gap-2" data-id="element-301">
                  <Star className="w-6 h-6 text-accent fill-accent" data-id="element-302" />
                  Incluido Hoy:
                </h3>

                <ul className="space-y-5" data-id="element-303">
                  <li className="flex items-start gap-4 p-3 rounded-xl hover:bg-warm-50 transition-colors" data-id="element-304">
                    <div className="bg-trust/10 p-1.5 rounded-full shrink-0" data-id="element-305">
                      <Check className="w-5 h-5 text-trust" data-id="element-306" />
                    </div>
                    <div data-id="element-307">
                      <span className="font-bold text-lg block text-charcoal" data-id="element-308">
                        Ebook Estratégico
                      </span>
                      <span className="text-charcoal-muted" data-id="element-309">
                        Manual paso a paso del Mecanismo de Fuego Criollo
                      </span>
                    </div>
                  </li>

                  <li className="flex items-start gap-4 p-3 rounded-xl hover:bg-warm-50 transition-colors" data-id="element-310">
                    <div className="bg-trust/10 p-1.5 rounded-full shrink-0" data-id="element-311">
                      <Check className="w-5 h-5 text-trust" data-id="element-312" />
                    </div>
                    <div data-id="element-313">
                      <span className="font-bold text-lg block text-charcoal" data-id="element-314">
                        Biblioteca de Recetas Anti‑Falla
                      </span>
                      <span className="text-charcoal-muted" data-id="element-315">
                        Chicharrón, patacón, arepa de queso, aborrajados
                      </span>
                    </div>
                  </li>

                  <li className="flex items-start gap-4 p-3 rounded-xl hover:bg-warm-50 transition-colors" data-id="element-316">
                    <div className="bg-trust/10 p-1.5 rounded-full shrink-0" data-id="element-317">
                      <Check className="w-5 h-5 text-trust" data-id="element-318" />
                    </div>
                    <div data-id="element-319">
                      <span className="font-bold text-lg block text-charcoal" data-id="element-320">
                        Checklist de Respuesta Rápida
                      </span>
                      <span className="text-charcoal-muted" data-id="element-321">
                        Pasos exactos para cocinar sin pensar
                      </span>
                    </div>
                  </li>

                  <li className="flex items-start gap-4 bg-gradient-to-r from-accent/10 to-transparent p-4 rounded-xl border border-accent/20 relative overflow-hidden" data-id="element-322">
                    <div className="absolute left-0 top-0 bottom-0 w-1 bg-accent" data-id="element-323"></div>
                    <div className="bg-accent/20 p-1.5 rounded-full shrink-0" data-id="element-324">
                      <Zap className="w-5 h-5 text-accent" data-id="element-325" />
                    </div>
                    <div data-id="element-326">
                      <span className="font-black text-lg text-accent block" data-id="element-327">
                        BONO: Recetario Proteína & Ligero
                      </span>
                      <span className="text-charcoal-muted font-medium" data-id="element-328">
                        20 recetas adicionales para el día a día
                      </span>
                    </div>
                  </li>
                </ul>
              </div>

              {/* Price Box */}
              <div className="lg:col-span-2" data-id="element-329">
                <div className="bg-charcoal text-white rounded-3xl p-8 shadow-2xl relative overflow-hidden flex flex-col justify-center items-center text-center h-full border border-charcoal-muted/30" data-id="element-330">
                  {/* Decorative glow inside price box */}
                  <div className="absolute inset-0 bg-gradient-to-br from-primary/20 to-transparent opacity-50" data-id="element-331"></div>

                  <div className="relative z-10 w-full" data-id="element-332">
                    <p className="text-gray-300 mb-3 text-lg" data-id="element-333">
                      Valor total:{' '}
                      <span className="line-through decoration-red-500 decoration-2" data-id="element-334">
                        $275.000 COP
                      </span>
                    </p>

                    <div className="inline-block bg-red-500 text-white font-black px-4 py-1.5 rounded-full text-sm mb-6 shadow-lg transform -rotate-2" data-id="element-335">
                      Ahorras un 87%
                    </div>

                    <p className="text-gray-300 font-medium mb-2 text-lg" data-id="element-336">
                      Hoy pagas solo:
                    </p>
                    <div className="text-6xl md:text-7xl font-heading font-black text-transparent bg-clip-text bg-gradient-to-r from-primary to-accent mb-6 drop-shadow-sm" data-id="element-337">
                      $23.999
                      <span className="block text-2xl text-gray-400 font-bold mt-2" data-id="element-338">
                        COP
                      </span>
                    </div>

                    <div className="flex flex-col items-center gap-2 text-red-400 font-bold bg-red-950/30 border border-red-900/50 px-4 py-3 rounded-xl w-full justify-center" data-id="element-339">
                      <span className="text-sm uppercase tracking-wider text-red-300" data-id="element-340">
                        La oferta expira en:
                      </span>
                      <div className="text-2xl text-white" data-id="element-341">
                        <CountdownTimer minutes={10} data-id="element-342" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* CTA */}
            <div className="flex flex-col items-center pt-8 border-t border-warm-100" data-id="element-343">
              <a id="buyNowTop" href="https://krove.lat//cart/40654113177729:1" className="w-full max-w-2xl bg-primary hover:bg-primary-hover text-white font-heading font-black text-xl md:text-3xl py-6 px-8 rounded-2xl shadow-[0_10px_30px_-5px_rgba(232,93,4,0.5)] hover:shadow-[0_20px_40px_-5px_rgba(232,93,4,0.7)] hover:-translate-y-1.5 transition-all duration-300 uppercase tracking-wide text-center flex items-center justify-center gap-3" data-id="element-344">
                Comprar ahora
                <Zap className="w-6 h-6 md:w-8 md:h-8 animate-pulse" data-id="element-345" />
              </a>

              <div className="flex flex-wrap justify-center gap-6 md:gap-10 mt-8" data-id="element-346">
                <div className="flex items-center gap-2 text-sm md:text-base text-charcoal-muted font-bold" data-id="element-347">
                  <Zap className="w-5 h-5 text-accent" data-id="element-348" /> Entrega inmediata
                </div>
                <div className="flex items-center gap-2 text-sm md:text-base text-charcoal-muted font-bold" data-id="element-349">
                  <ShieldCheck className="w-5 h-5 text-trust" data-id="element-350" /> Acceso de por
                  vida
                </div>
                <div className="flex items-center gap-2 text-sm md:text-base text-charcoal-muted font-bold" data-id="element-351">
                  <Check className="w-5 h-5 text-trust" data-id="element-352" /> Garantía 7 días
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}